import {
  Box,
  Center,
  Collapse,
  Text,
  useMediaQuery,
  VStack,
} from "@chakra-ui/react";
import Image from "next/image";
// @ts-ignore unused import on React
import React from "react";

import { Rating, RichTextEditorContent } from "@components/atoms";
import { H1 } from "@components/atoms/Text/H1";
import { ProductListHeaderFilterBar } from "@components/molecules/ProductListHeaderFilterBar/ProductListHeaderFilterBar";
import { defaultTheme } from "@styles";
import { breakpoints } from "@styles/constants";
import { SORT_OPTIONS } from "@utils/collections";
import { getActiveFilterAttributes } from "@utils/filters";
import { imageLoader } from "@utils/images";
import { PageTypes } from "@utils/ssr";

import * as S from "./styles";
import { IProps } from "./types";

export const ProductListHeader = ({
  title,
  seoDescription,
  aboveProductsDescription,
  showFilters,
  setShowFilters,
  activeSortOption,
  numberOfProducts,
  activeFilters,
  filters,
  attributes,
  clearFilters,
  locationFilter,
  onLocationFilterChange,
  pricesFilter,
  onPricesFilterChange,
  deliveryFilter,
  setDeliveryFilter,
  onOrder,
  onAttributeFiltersChange,
  lenderInfo,
  infiniteScrollingMode,
  keyword,
  setKeyword,
  displayLoader,
  pageType,
  aboveProductContent,
}: IProps) => {
  const [isDesktop] = useMediaQuery(`(min-width: ${breakpoints.xl})`);

  const ordersMade = lenderInfo?.lenderOrdersMade || 0;

  return (
    <>
      <Box backgroundColor={defaultTheme.colors.white} w="full">
        <Box maxWidth="75rem" marginX="auto">
          <Collapse in={!infiniteScrollingMode}>
            <Box marginX="auto" maxWidth="fit-content" textAlign="center">
              {lenderInfo?.avatar?.url && (
                <Image
                  src={lenderInfo.avatar?.url}
                  alt={`${lenderInfo.name} Profile Image`}
                  width={80}
                  height={80}
                  loader={imageLoader}
                  loading="lazy"
                  objectFit="contain"
                />
              )}

              {pageType?.slug === PageTypes.DESIGNER ? (
                <div
                  className="article-page__header"
                  style={{ marginBottom: "18px" }}
                >
                  <h1>{title}</h1>
                </div>
              ) : (
                <H1 mt={0} fontSize="3xl">
                  {title}
                </H1>
              )}
              {lenderInfo && !infiniteScrollingMode && (
                <Box
                  margin="0 auto"
                  maxWidth="fit-content"
                  minWidth="200px"
                  paddingTop="1.5rem"
                  display="flex"
                  flexDirection="row"
                  gap="1rem"
                  fontSize={18}
                >
                  <S.ProductLenderContainer>
                    <Rating
                      // @ts-ignore
                      size={32}
                      // scale={5}
                      rate={lenderInfo.rating}
                      fillColor="#000"
                      showText
                    />
                    <S.ProductLenderInnerContainer>
                      {ordersMade >= 3 && (
                        <S.ProductListHeaderContainer>
                          <S.ProductListHeaderText>
                            {lenderInfo.lenderOrdersMade}
                          </S.ProductListHeaderText>
                          {ordersMade === 1 ? <p>Order</p> : <p>Orders</p>}
                        </S.ProductListHeaderContainer>
                      )}
                      <S.ProductListHeaderContainer>
                        <S.ProductListHeaderText>
                          {numberOfProducts}
                        </S.ProductListHeaderText>
                        {numberOfProducts === 1 ? (
                          <p>Item to Rent</p>
                        ) : (
                          <p>Items to Rent</p>
                        )}
                      </S.ProductListHeaderContainer>
                    </S.ProductLenderInnerContainer>
                  </S.ProductLenderContainer>
                </Box>
              )}
              <Center>
                <VStack maxWidth="1024px">
                  {aboveProductContent && (
                    <RichTextEditorContent
                      jsonData={aboveProductContent}
                      sanitizationNotRequired
                    />
                  )}

                  {seoDescription && !aboveProductContent && (
                    <Text fontSize="sm">{seoDescription}</Text>
                  )}

                  {aboveProductsDescription && (
                    <Text fontSize="sm">{aboveProductsDescription}</Text>
                  )}
                </VStack>
              </Center>
            </Box>
          </Collapse>
        </Box>
      </Box>
      <ProductListHeaderFilterBar
        activeSortOption={activeSortOption}
        openFiltersMenu={() => setShowFilters(true)}
        numberOfProducts={numberOfProducts}
        activeFilters={activeFilters}
        activeFiltersAttributes={
          getActiveFilterAttributes(filters?.attributes, attributes) || []
        }
        clearFilters={clearFilters}
        pricesFilter={pricesFilter}
        onPricesFilterChange={onPricesFilterChange}
        locationFilter={locationFilter}
        onLocationFilterChange={onLocationFilterChange}
        sortOptions={SORT_OPTIONS}
        onChange={onOrder}
        onCloseFilterAttribute={onAttributeFiltersChange}
        mobile={!isDesktop}
        showFilters={showFilters}
        lenderView={!!lenderInfo}
        deliveryFilter={deliveryFilter}
        setDeliveryFilter={setDeliveryFilter}
        title={infiniteScrollingMode ? title : ""}
        lenderRating={filters?.lenderRating}
        keyword={keyword}
        setKeyword={setKeyword}
        displayLoader={displayLoader}
      />
    </>
  );
};
